/**
 * Which brand portal this page is being served from.
 *
 * Production: the page hostname itself — `<slug>.reveshare.com` is a portal,
 * anything else is the marketplace. The backend owns the actual rule
 * (`GET /white-label/resolve`); the client only reports the host.
 *
 * Local development and e2e run on localhost, which can never be a portal. To
 * preview a brand's portal there, set `sessionStorage[PORTAL_DEV_HOST_KEY]`
 * to the portal host (e.g. `lumen-lane.reveshare.com`) and reload. Honoured
 * on local hostnames only, so it is inert in production.
 */
export const PORTAL_DEV_HOST_KEY = "portalBranding.devHost";

export function isLocalHostname(hostname: string): boolean {
  return (
    hostname === "localhost" ||
    hostname === "[::1]" ||
    /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)
  );
}

/** Host (with port, if any) to resolve branding from and to report on sign-in. */
export function currentPortalHost(): string {
  const { hostname, host } = window.location;
  if (isLocalHostname(hostname)) {
    try {
      const override = sessionStorage.getItem(PORTAL_DEV_HOST_KEY);
      if (override) return override;
    } catch {
      // Storage unavailable: behave as plain localhost.
    }
  }
  return host;
}

/** Hostname part of a host:port string. */
export function hostnameOf(host: string): string {
  return host.split(":")[0];
}
